import MemoryCard from './MemoryCard';

const GalleryGrid = ({ photos, onPhotoClick }) => {
  if (!photos?.length) return null;

  return (
    <div className="grid grid-cols-3 gap-1 sm:gap-1.5 md:grid-cols-4">
      {photos.map((photo, i) => (
        <MemoryCard
          key={photo._id}
          photo={photo}
          index={i}
          onClick={onPhotoClick}
        />
      ))}
    </div>
  );
};

export default GalleryGrid;
